import React from 'react';

const Header = ({ onLogout }) => {
  return (
    <header className="d-flex justify-content-between align-items-center py-3 px-3 px-md-4">
      <div>
        <div className="admin-header-title">Admin Dashboard</div>
        <div className="admin-header-subtitle">Manage Blue Nest Hotel content</div>
      </div>
      <button className="btn admin-logout-btn" onClick={onLogout}>
        Logout
      </button>
    </header>
  );
};

export default Header;
